/*
 * Address messages
 *
 * This contains all the text for the Address component
 *
 * NOTE: This is also accessed in:
 * - app/components/Address/addressValidation.jsx
 * - app/components/Address/addressValidation.test.js
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  billingTitle: {
    id: 'common.titles.billingAddress',
    defaultMessage: 'Billing address',
  },
  shippingTitle: {
    id: 'common.titles.shippingAddress',
    defaultMessage: 'Shipping address',
  },
  change: {
    id: 'components.Address.change',
    defaultMessage: 'I want to change my billing address',
  },
  continue: {
    id: 'common.buttons.continue',
    defaultMessage: 'Continue',
  },
  validationError: {
    id: 'common.titles.validationError',
    defaultMessage: '{field} is required.',
  },
  maxLengthValidationError: {
    id: 'common.titles.maxLengthValidationError',
    defaultMessage: 'Max. character count is {maxLength}. Please reduce.',
  },
  shouldMatchError: {
    id: 'common.titles.shouldMatchError',
    defaultMessage: 'Use the same {field} for shipping and billing address',
  },
});
